import React, { useState } from 'react';
import { useApp } from '../contexts/AppContext';
import LeaveRequest from './LeaveRequest';
import Ziekmelding from './Ziekmelding';
import OvertimeTracker from './OvertimeTracker';
import FlexDashboard from './FlexDashboard';

const types = [
  { key: 'verlof', icon: '✈️', label: 'Verlof aanvragen', desc: 'Vakantie, bijzonder verlof of Flex/ADV', color: '#107C10' },
  { key: 'ziek', icon: '🏥', label: 'Ziekmelding', desc: 'Ziek- of betermelding registreren', color: '#D13438' },
  { key: 'overuren', icon: '⏰', label: 'Overuren registreren', desc: 'Extra gewerkte uren vastleggen', color: '#E86E1C' },
];

const managerTypes = [
  ...types,
  { key: 'flex', icon: '⚡', label: 'Flexkracht inplannen', desc: 'Flexkracht inroosteren en uren beheren', color: '#0078D4' },
];

function Indienen() {
  const { canManage } = useApp();
  const [activeType, setActiveType] = useState(null);
  const availableTypes = canManage ? managerTypes : types;

  if (activeType) {
    return (
      <div>
        <button onClick={() => setActiveType(null)} style={{
          display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 16px',
          border: '1px solid #edebe9', borderRadius: 8, background: '#fff', color: '#605e5c',
          fontSize: 13, fontWeight: 600, cursor: 'pointer', marginBottom: 16,
        }}>
          ← Terug naar keuze
        </button>
        {activeType === 'verlof' && <LeaveRequest />}
        {activeType === 'ziek' && <Ziekmelding />}
        {activeType === 'overuren' && <OvertimeTracker />}
        {activeType === 'flex' && <FlexDashboard embedded />}
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 700 }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)',
        borderRadius: 16, padding: '28px 32px', color: '#fff', marginBottom: 24,
      }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>📝 Indienen</h2>
        <p style={{ fontSize: 14, opacity: 0.7 }}>
          {canManage ? 'Kies wat je wilt registreren of indienen namens een medewerker' : 'Kies wat je wilt indienen'}
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {availableTypes.map(t => (
          <button key={t.key} onClick={() => setActiveType(t.key)} style={{
            display: 'flex', alignItems: 'center', gap: 16, padding: '20px 24px',
            background: '#fff', border: '2px solid #edebe9', borderRadius: 14,
            cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = t.color; e.currentTarget.style.background = `${t.color}08`; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = '#edebe9'; e.currentTarget.style.background = '#fff'; }}
          >
            <span style={{
              width: 52, height: 52, borderRadius: 14, background: `${t.color}15`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 26, flexShrink: 0,
            }}>{t.icon}</span>
            <div>
              <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e' }}>{t.label}</div>
              <div style={{ fontSize: 13, color: '#605e5c', marginTop: 2 }}>{t.desc}</div>
            </div>
            <span style={{ marginLeft: 'auto', fontSize: 18, color: '#a19f9d' }}>›</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default Indienen;
